import {createAsyncThunk} from '@reduxjs/toolkit'
import {api2Endpoint} from 'app/config/apiConfig'
import {getData} from 'app/hooks/api/useGetData'
import {putData} from 'app/hooks/api/usePutData'
import {IUserFE} from 'interfaces/IUserFE'
import {AppDispatch, RootState} from 'redux/store'

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState
  dispatch: AppDispatch
}>()

export const fetchUser = createAppAsyncThunk('user/fetchUser', async () => {
  try {
    const response = await getData<IUserFE>(api2Endpoint(`std/user/self`))
    if (!response) {
      return undefined
    }
    return response
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred'
    return undefined
  }
})

export const updateUserAsncThunk = createAsyncThunk(
  'user/updateUser',
  async (args: {id: string; updateUserPart: Partial<IUserFE>; originalUser: IUserFE}) => {
    const {id, updateUserPart, originalUser} = args
    try {
      const response = await putData<IUserFE>(api2Endpoint(`std/user/${id}`), updateUserPart)
      if (!response) {
        throw new Error('Failed to update user')
      } else {
        //this needs to update all things off the user object being updated (Favorites, filters, )
        //but it seems it would since it's the whole object.
        //the favorites need to be derived off the user object, same with filters,
        const newUser = {...originalUser, ...updateUserPart}
        return newUser
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred'
    }
  }
)
